export enum BookingFormStepEnum {
  ChooseEmployeeAndTimeSlot,
  CustomerDataForm
}
